import { createSlice, type PayloadAction } from "@reduxjs/toolkit";


export interface UIState {
  tournamentMatches: boolean;
}

const initialState: UIState = {
  tournamentMatches: false,
};

const matchesUiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setTournamentMatches(state, action: PayloadAction<boolean>) {
      state.tournamentMatches = action.payload;
    },
    // optional helper:
    toggleTournamentMatches(state) {
      state.tournamentMatches = !state.tournamentMatches;
    },
    resetUI() {
      return initialState;
    },
  },
});

export const { setTournamentMatches, toggleTournamentMatches, resetUI } = matchesUiSlice.actions;
export default matchesUiSlice.reducer;
